<span class="search-wrapper" [ngClass]="{'active': isSearchActive}">
  <input clrInput #inputBox type="text" class="search-box" placeholder="{{ 'Search' }}" (keyup)="update.emit(inputBox.value)" (blur)="onSearchBlur()" />
  <clr-icon shape="search" class="search-btn" size="24" (click)="onSearchClick();" [ngClass]="{'filtered': inputBox.value }"></clr-icon>
</span>
